import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setContato, setConversa, setEmpresa, setNegocio, setGrupoWhatsapp } from 'src/redux/slices/global';

import Iconify from 'src/components/Iconify';
import { Button } from 'src/@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from 'src/@/components/ui/dropdown-menu';
import { verifyRules } from 'src/utils/functions';

// ----------------------------------------------------------------------

MenuOptionsNovo.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object
};

export default function MenuOptionsNovo({
    children,
    sx,
    inicial,
    final,
    changeInicial,
    changeFinal,
    onSelect: onSelectProp, // Rename to avoid conflict if needed, though unused in original body aside from shadowing
    onPesquisar,
    leadsKanban,
    colunas,
    ordemColunas,
    periodo,
    pipelineId,
    qualificacao,
    responsaveis,
    user,
    cliente,
    ...other
}) {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);

    async function handleSelect(value) {
        if (value === 'negocio') {
            dispatch(setNegocio({ loading: false, openModal: true }));
        } else if (value === 'empresa') {
            dispatch(setEmpresa({ loading: false, openModal: true }));
        } else if (value === 'conversa') {
            dispatch(setConversa({ loading: false, openModal: true }));
        } else if (value === 'contato') {
            dispatch(setContato({ loading: false, openModal: true }));
        } else if (value === 'grupo') {
            dispatch(setGrupoWhatsapp({ loading: false, openModal: true }));
        }
        setOpen(false);
    }

    return (
        <DropdownMenu open={open} onOpenChange={setOpen}>
            <DropdownMenuTrigger asChild>
                <Button
                    className="h-7 text-sm rounded-md bg-gradient-to-r from-violet-500 to-indigo-600 hover:from-violet-700 hover:to-indigo-700 flex items-center text-white border-0 shadow-md transition-all duration-300"
                    onClick={() => setOpen(true)}
                >
                    Criar
                    <Iconify className="text-white ml-1 mt-0.5" icon="mdi:add-bold" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="w-[200px] p-1"
                {...other}
            >
                <DropdownMenuItem onClick={() => handleSelect('conversa')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={16} height={16} icon={'ri:whatsapp-fill'} />
                        <span className="text-[13px] font-semibold">Conversa</span>
                    </div>
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => handleSelect('negocio')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={16} height={16} icon={'streamline:subscription-cashflow'} />
                        <span className="text-[13px] font-semibold">Negócio</span>
                    </div>
                </DropdownMenuItem>

                <DropdownMenuItem onClick={() => handleSelect('contato')} className="cursor-pointer">
                    <div className="flex flex-row items-center gap-2 mb-0.5">
                        <Iconify width={18} height={18} icon={'material-symbols:person-outline'} />
                        <span className="text-[13px] font-semibold">Contato</span>
                    </div>
                </DropdownMenuItem>

                {verifyRules(user?.rules, 'criar_grupo_whatsapp') && (
                    <DropdownMenuItem onClick={() => handleSelect('grupo')} className="cursor-pointer">
                        <div className="flex flex-row items-center gap-2 mb-0.5">
                            <Iconify width={16} height={16} icon={'solar:users-group-rounded-bold'} />
                            <span className="text-[13px] font-semibold">Grupo</span>
                        </div>
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}




